module.exports = __webpack_public_path__ + "img/vita.a78059c.svg";